/** @file Field: a labelled form row wrapping one control (stacked, or inline with `inline`). */
import type { ReactElement, ReactNode } from 'react';

/** The label text, the control, and whether label and control share one row. */
export type FieldProps = { label: string; inline?: boolean; children: ReactNode };

/** A `<label>` around its control, so clicking the text focuses the control. */
export function Field({ label, inline = false, children }: FieldProps): ReactElement {
  return (
    <label className={inline ? 'p3-field p3-field-row' : 'p3-field'}>
      <span>{label}</span>
      {children}
    </label>
  );
}
